import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
type TypeScriptLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const TypeScriptLogo: React.FC<TypeScriptLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "TypeScript logo";
    t9 = cn("stroke-[#0369A1]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16534)"><path d="M20 23.3333C20.4267 23.76 21.0053 24 21.6093 24H22.3333C23.2533 24 24 23.2533 24 22.3333V22C24 21.4696 23.7893 20.9609 23.4142 20.5858C23.0391 20.2107 22.5304 20 22 20C21.4696 20 20.9609 19.7893 20.5858 19.4142C20.2107 19.0391 20 18.5304 20 18V17.6667C20 16.7467 20.7467 16 21.6667 16H22.3907C22.9947 16 23.5733 16.24 24 16.6667" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 16H17.3333" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M14.667 16V24" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M28 25.3333V6.66667C28 5.95942 27.719 5.28115 27.219 4.78105C26.7189 4.28095 26.0406 4 25.3333 4H6.66667C5.95942 4 5.28115 4.28095 4.78105 4.78105C4.28095 5.28115 4 5.95942 4 6.66667V25.3333C4 26.0406 4.28095 26.7189 4.78105 27.219C5.28115 27.719 5.95942 28 6.66667 28H25.3333C26.0406 28 26.7189 27.719 27.219 27.219C27.719 26.7189 28 26.0406 28 25.3333Z" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16534"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};